import { useEffect, useRef, useState } from 'react';
import { Box, Container } from '@mui/material';

import CameraFull from './components/CameraFull';
import Carrousel, { BuscaProdutoItem } from './components/Carrousel';
import api from '@core/services/api';

interface IBuscaProdutoProps { }

export function BuscaProduto(props: IBuscaProdutoProps) {

	const [matches, setMatches] = useState<null | Array<BuscaProdutoItem>>(null);

	async function postImageToApi(base64Image: string) {
		// Remove o prefixo 'data:image/jpeg;base64,' se estiver presente
		const base64Data = base64Image.replace(/^data:image\/jpeg;base64,/, '');

		api.post<any>(`/api/varejo/busca-produto`,
			{ base64image: base64Data },
			{
				headers: {
					"Content-Type": "application/json"
				}
			})
			.then((response: any) => {
				console.log(response.data);
				setMatches(response.data);
			})
			.catch((e: any) => {
				console.log(e);
				setMatches(null);
			})
	}

	function onCapture(img: any) {
		console.log("Imagem capturada!", img);

		postImageToApi(img);
	}

	if (matches != null) {
		return (
			<Container>
				<Box>
					<Carrousel images={matches} />
				</Box>
			</Container>
		);
	}

	return (
		<CameraFull
			onCapture={(img: any) => onCapture(img)}
		/>
	);
}
